import { render, staticRenderFns } from "./celebrities.vue?vue&type=template&id=94995cea&"
import script from "./celebrities.vue?vue&type=script&lang=js&"
export * from "./celebrities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports